(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/customer-login/assets/javascripts/login.js') >= 0) return;  svs.modules.push('/components/components/customer-login/assets/javascripts/login.js'); "use strict";

(function ($, svs) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.customer_login = svs.components.customer_login || {};

  svs.components.customer_login.login = function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var extraParams = '';

    if (options.extraParams) {
      extraParams = Object.keys(options.extraParams).reduce(function (acc, key) {
        return "".concat(acc, "&").concat(encodeURIComponent(key), "=").concat(encodeURIComponent(options.extraParams[key]));
      }, '');
    }

    svs.utils.url.navigate(svs.utils.url.join(svs.core.urlMapping.get('loginHome'), "?returnUrl=".concat(encodeURIComponent(svs.utils.url.makeInternal(svs.utils.url.currentPathEncodedParams()))).concat(extraParams, "&w=t").concat(options.returnNewCustomer ? '&rnc=true' : '')));
  };
})(jQuery, svs);
 })(window);